
import { Placement } from '@post-office/placements-frontend/adminhub-inbox-recommendation';
export default Placement;
